import React from 'react';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { Font, Dimensions } from 'components/visuals';
import {
  LicenseType,
  LICENSE_COMMUNITY,
  LICENSE_OPENSOURCE,
  LICENSE_ACADEMIC,
  LICENSE_SOCIAL_IMPACT,
  LICENSE_SOCIAL_IMPACT_GLOBAL_ACCESS,
} from 'model/hams/LicenseType';

const DetailsWrapper = styled.div`
  font-size: 12px;
  line-height: 16px;
`;

const LicenseWrapper = styled.p`
  background-color: ${token('color.border', '#B3B9C4')};
  font-family: ${Font.displayFamily};
  font-size: ${Dimensions.units(1.5)}px;
  font-weight: 500;
  text-align: center;
  color: ${token('color.text', '#172B4D')};
  margin-top: ${Dimensions.units(2)}px;
  text-transform: uppercase;
  width: fit-content;
  padding: 0 ${Dimensions.units(0.5)}px;
  border-radius: 3px;
`;

interface Props {
  accountId: number | string;
  accountName: string;
  expiryDate?: string;
  licenseType?: LicenseType;
  isNonCommercialOn: boolean;
  ownerEmail?: string;
}

const AccountDetails = ({
  accountId,
  accountName,
  expiryDate,
  licenseType,
  isNonCommercialOn,
  ownerEmail,
}: Props) => (
  <DetailsWrapper>
    {expiryDate && (
      <FormattedMessage
        id="migrate.table.row.expiry"
        values={{
          date: (
            <FormattedDate
              value={new Date(expiryDate)}
              day="numeric"
              month="short"
              year="numeric"
            />
          ),
        }}
      />
    )}
    <div> {`SEN-${accountId}`} </div>
    <div> {accountName} </div>
    {ownerEmail && <div> {ownerEmail} </div>}
    {isNonCommercialOn && licenseType && (
      <LicenseWrapper>
        {licenseType === LICENSE_OPENSOURCE && (
          <FormattedMessage id="migrate.table.row.licenseType.opensource" />
        )}
        {licenseType === LICENSE_ACADEMIC && (
          <FormattedMessage id="migrate.table.row.licenseType.academic" />
        )}
        {licenseType === LICENSE_COMMUNITY && (
          <FormattedMessage id="migrate.table.row.licenseType.community" />
        )}
        {(licenseType === LICENSE_SOCIAL_IMPACT ||
          licenseType === LICENSE_SOCIAL_IMPACT_GLOBAL_ACCESS) && (
          <FormattedMessage id="migrate.table.row.licenseType.social" />
        )}
      </LicenseWrapper>
    )}
  </DetailsWrapper>
);

export default AccountDetails;
